import { useAppSelector } from '@/hooks/use.redux';

export function useConfigs() {
  const { banners, supportPhoneNumber, latestVersion } = useAppSelector((state) => state.configsReducer);
  return {
    supportPhoneNumber,
    banners,
    latestVersion,
  };
}
